export default __webpack_public_path__ + "static/media/whats.1ff4b6aa.svg";